export enum EmailProviderType {
  Mailgun = 'Mailgun',
  Nylas = 'Nylas',
}
